import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { d as defineCustomElement$i } from './p-BbTg3Car.js';
import { d as defineCustomElement$h } from './p-D5W-FK48.js';
import { d as defineCustomElement$g } from './p-BwWHobpA.js';
import { d as defineCustomElement$f } from './p-sF9rvBC9.js';
import { d as defineCustomElement$e } from './p-9214Ox4g.js';
import { d as defineCustomElement$d } from './p-D73QFTB_.js';
import { d as defineCustomElement$c } from './p-RWl7wfjL.js';
import { d as defineCustomElement$b } from './p-zhqqpN2G.js';
import { d as defineCustomElement$a } from './p-BDIehgMZ.js';
import { d as defineCustomElement$9 } from './p-DKss2Fy6.js';
import { d as defineCustomElement$8 } from './p-lnuA9A6c.js';
import { d as defineCustomElement$7 } from './p-Cullta-8.js';
import { d as defineCustomElement$6 } from './p-CW-Ftoto.js';
import { d as defineCustomElement$5 } from './p-BYQE4OHw.js';
import { d as defineCustomElement$4 } from './p-HDOuhNRM.js';
import { d as defineCustomElement$3 } from './p-Trmgzgcp.js';
import { d as defineCustomElement$2 } from './p-KbTC_jnR.js';

const thumbnailGridCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.content{display:flex;flex-wrap:wrap;gap:1rem;height:100%;overflow-y:auto;width:100%}.content .header{position:sticky;top:0;width:100%;z-index:7}.content .header .header-wrapper{align-content:center;display:flex;justify-content:space-between;min-height:2rem;width:100%}.state-empty,.state-error,.state-loading{align-items:center;background-color:var(--jw-theme-surface-level1-default-bg-color);display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;justify-content:center;letter-spacing:-.0004em;line-height:1.25rem;min-height:15rem}.state-error{color:var(--jw-theme-form-validation-error-color);gap:.25rem}:host([scroll-size=sm][size=sm]) .content{max-height:7rem}:host([scroll-size=sm][size=md]) .content{max-height:10rem}:host([scroll-size=sm][size=lg]) .content{max-height:19rem}:host([scroll-size=sm][size=xl]) .content{max-height:21rem}:host([scroll-size=md][size=sm]) .content{max-height:11rem}:host([scroll-size=md][size=md]) .content{max-height:15.5rem}:host([scroll-size=md][size=lg]) .content{max-height:29rem}:host([scroll-size=md][size=xl]) .content{max-height:32rem}:host([scroll-size=lg][size=sm]) .content{max-height:15rem}:host([scroll-size=lg][size=md]) .content{max-height:21rem}:host([scroll-size=lg][size=lg]) .content{max-height:39rem}:host([scroll-size=lg][size=xl]) .content{max-height:43rem}";

const defaultEmptyState = {
    icon: 'empty',
    heading: 'No images have been added',
    description: 'Added images will appear here.',
};
const WuiThumbnailGrid$1 = /*@__PURE__*/ proxyCustomElement(class WuiThumbnailGrid extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.delete = createEvent(this, "delete", 3);
        this.edit = createEvent(this, "edit", 3);
        /**
         * List of thumbnail items
         */
        this.thumbnails = [];
        /**
         * If a bulk-actions bar should be shown
         */
        this.bulkSelect = false;
        /**
         * Size of each thumbnails in the grid
         */
        this.size = 'lg';
        /**
         * Blur background for thumbnail
         */
        this.blurImage = true;
        this.handleCheckAllInput = (e) => {
            e.stopPropagation();
            if (this.areAllOptionsChecked()) {
                this.setValue([]);
            }
            else {
                this.setValue(this.thumbnails?.map((el) => el.id));
            }
        };
        this.handleInput = (e, id) => {
            e.stopPropagation();
            const target = e.target;
            const { checked } = target;
            if (this.disabled) {
                e.preventDefault();
                return;
            }
            if (checked) {
                this.setValue([...(this.value || []), id]);
            }
            else {
                this.setValue(this.value?.filter((i) => i !== id));
            }
        };
        this.handleEdit = (evt, id) => {
            evt.stopPropagation();
            if (this.disabled || !id) {
                evt.preventDefault();
                return;
            }
            this.edit.emit(id);
        };
        this.handleDelete = (evt, id) => {
            evt.stopPropagation();
            if (this.disabled || !id) {
                evt.preventDefault();
                return;
            }
            this.delete.emit([id]);
        };
        this.handleBulkDelete = (e) => {
            e.stopPropagation();
            this.delete.emit(this.value);
        };
        this.isChecked = (id) => {
            return Boolean(this.value?.includes(id));
        };
        this.areSomeOptionsChecked = () => {
            return (typeof this.thumbnails !== 'undefined' &&
                typeof this.value !== 'undefined' &&
                this.value.length > 0 &&
                this.value.length !== this.thumbnails.length);
        };
        this.areAllOptionsChecked = () => {
            return (typeof this.thumbnails !== 'undefined' &&
                typeof this.value !== 'undefined' &&
                this.value.length === this.thumbnails.length);
        };
        this.isEmpty = () => {
            return Boolean(!this.error && !this.loading && !this.thumbnails?.length);
        };
        this.showThumbnails = () => {
            return Boolean(!this.error && !this.loading && this.thumbnails?.length);
        };
    }
    setValue(value) {
        this.value = value;
        this.elm.dispatchEvent(new window.Event('input', { bubbles: true }));
    }
    render() {
        return (h(Host, { key: '4c42153077d190aa000f61bd8abd06f382bd3ee9' }, this.loading && (h("div", { key: '6845f32855f1518b4f3f08debcecfb089ba2a8f7', class: "state-loading" }, h("wui-loader", { key: '3bee116eb9c58184475fec39397ca6e18d921c95', size: "lg" }))), !this.loading && this.error && (h("div", { key: 'a9488be36120e620e251afd6036d74fbc03a2b42', class: "state-error" }, h("wui-icon", { key: 'dc864c3dce9668b17e0a3e50aba6d21abe85437e', name: "alert-circle", size: "xl" }), this.error.message)), !this.loading && !this.error && this.isEmpty() && (h("wui-empty-state", { key: '3421e2de11177ce369b21bb21452f9f26471ae3c', contents: this.emptyStateContent ? this.emptyStateContent : defaultEmptyState })), this.showThumbnails() && (h("div", { key: '78586216014849ce434fdb0e1cc9a7aa9e3d22e9', class: "content" }, this.bulkSelect && (h("wui-component-header", { key: '16c9333073a94a7c72788c7faa63edab81b56314', class: "header" }, h("div", { key: 'a8e73e813ece04b8c22a58f88880baf419834836', class: "header-wrapper" }, h("wui-check-input", { key: '55fe79113a5145db2202a8d8068c24ac3bf2da5d', checked: this.areAllOptionsChecked(), disabled: this.disabled, onInput: this.handleCheckAllInput, label: this.areAllOptionsChecked() ? `${this.value?.length || 0} selected` : 'Select all', indeterminate: this.areSomeOptionsChecked() }), (this.areSomeOptionsChecked() || this.areAllOptionsChecked()) && (h("wui-button", { key: 'd61457e49197d017c1784fae5922f99e88e69f45', label: "Delete", intent: "error", icon: "trash", type: "tertiary", onClick: this.handleBulkDelete }))))), this.thumbnails?.map(({ id, label, badge, src, ...rest }) => (h("wui-thumbnail", { key: id, label: label, badge: badge, src: src, blurImage: this.blurImage, size: this.size, checked: this.isChecked(id), checkable: !this.disabled && this.bulkSelect, disabled: this.disabled, onInput: (e) => this.handleInput(e, id), hoverActions: [
                {
                    type: 'tertiary',
                    label: 'Edit',
                    icon: 'pencil',
                    onClick: (e) => this.handleEdit(e, id),
                },
                {
                    type: 'tertiary',
                    label: 'Delete',
                    icon: 'trash',
                    onClick: (e) => this.handleDelete(e, id),
                },
            ], ...rest })))))));
    }
    get elm() { return this; }
    static get style() { return thumbnailGridCss; }
}, [257, "wui-thumbnail-grid", {
        "thumbnails": [16],
        "bulkSelect": [4, "bulk-select"],
        "size": [513],
        "blurImage": [4, "blur-image"],
        "error": [16],
        "value": [1040],
        "loading": [4],
        "disabled": [4],
        "scrollSize": [513, "scroll-size"],
        "emptyStateContent": [16, "empty-state-content"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-thumbnail-grid", "wui-box", "wui-button", "wui-check-input", "wui-close-button", "wui-component-header", "wui-empty-state", "wui-form-field", "wui-graph-icon", "wui-icon", "wui-layout", "wui-loader", "wui-logo", "wui-status", "wui-tag", "wui-thumbnail", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-thumbnail-grid":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiThumbnailGrid$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$i();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$h();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$g();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$f();
            }
            break;
        case "wui-component-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "wui-empty-state":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-graph-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-logo":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-tag":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-thumbnail":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiThumbnailGrid = WuiThumbnailGrid$1;
const defineCustomElement = defineCustomElement$1;

export { WuiThumbnailGrid, defineCustomElement };
